import React from 'react'
import Reveal from './layout/Reveal'
import LaurelBadge from './LaurelBadge'

/**
 * Awards / laurels band directly above the footer (Parity V2 A.2).
 * All claims verified — see brief A.2 for sources.
 */
const AWARDS: [string, string, string][] = [
  ['Delaware Today', 'Top Real Estate Agents', '2026'],
  ['Delaware Today', 'Faces of Delaware', '2025'],
  ['NAR', 'Resort & Second Home', 'Specialist'],
  ['Zillow', 'Premier', 'Agent'],
  ['Top-Selling Realtors®', 'State of Delaware', 'Since 2017'],
  ['Jack Lingo Realtor®', 'Trusted at the Beaches', 'Since 1974'],
]

const AwardsBand: React.FC = () => {
  return (
    <section aria-label="Awards and recognition" className="relative overflow-hidden bg-ink">
      {/* Ambient gold glow behind the badges (Polish Plan item 5.4) */}
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(230,140,115,0.12),transparent_60%)]"
      />
      <div className="relative max-w-1200 mx-auto px-6 py-16 md:py-20">
        <Reveal>
          <div className="text-center mb-12">
            {/* Verified social profile image replaces the generated brand monogram. */}
            <img
              src="/media/team/merritt-shawn-profile.jpg"
              alt="Merritt Cooch and Shawn McDonnell"
              width={320}
              height={320}
              className="mx-auto h-16 w-16 rounded-full border-2 border-white/70 object-cover shadow-lg md:h-20 md:w-20"
            />
            <p className="mt-3 font-sans text-xl font-medium tracking-[0.04em] text-white">
              Merritt &amp; Shawn
              <span className="mt-1 block text-[9px] uppercase tracking-[0.22em] text-white/65 md:text-[10px]">Coastal Delaware Real Estate</span>
            </p>
          </div>
        </Reveal>

        <div className="flex flex-wrap items-start justify-center gap-8 md:gap-10 lg:flex-nowrap lg:justify-between lg:gap-3 xl:gap-5">
          {AWARDS.map((lines, i) => (
            <Reveal key={lines.join()} delay={i * 120} className="shrink-0">
              <LaurelBadge lines={lines} animate />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AwardsBand
